import React, { useEffect, useState } from 'react';
import Loader from '../../../components/Loader';
import ApiService from '../../../services/ApiService';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import moment from 'moment';

// Bootstrap badge class per approval state.
const approvalBadge = (status) => {
  if (status === 'Approved') return 'badge-light-success';
  if (status === 'Rejected') return 'badge-light-danger';
  return 'badge-light-warning';
};

const CustomerMemberships = ({ userId }) => {
  const [isLoader, setIsLoader] = useState(false);
  const [memberships, setMemberships] = useState([]);

  useEffect(() => {
    getMemberships();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const getMemberships = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: 'admin/membership-plans/subscribers',
        data: { user_id: userId, limit: 50 },
      });
      const data = response.data;
      if (data.status) {
        setMemberships(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoader(false);
    }
  };

  const updateApproval = async (id, approval_status) => {
    const isApprove = approval_status === 'Approved';
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: isApprove
        ? 'This will charge the authorised payment and activate the membership.'
        : 'This will release the payment hold and reject the membership.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: isApprove ? '#4BC95F' : '#d33',
      confirmButtonText: isApprove ? 'Yes, approve' : 'Yes, reject',
      cancelButtonColor: '#9E9B9B',
      cancelButtonText: 'No',
    });

    if (result.isConfirmed) {
      try {
        const response = await ApiService.request({
          method: 'POST',
          url: `admin/membership-plans/subscribers/${id}/approval`,
          data: { approval_status },
        });
        const data = response.data;
        if (data.status) {
          getMemberships();
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        toast.error('Something went wrong.');
      }
    }
  };

  if (isLoader) {
    return <Loader text="Loading" size="30" className="text-center" />;
  }

  return (
    <div className="card">
      <div className="card-header border-0 pt-6">
        <h3 className="card-title fw-bold m-0">Membership History</h3>
      </div>
      <div className="card-body pt-4">
        {memberships.length === 0 ? (
          <div className="text-center text-muted py-10">
            <i className="bi bi-award fs-2x mb-3 d-block"></i>
            <p className="mb-0">No memberships found</p>
          </div>
        ) : (
        <div className="table-responsive">
          <table className="table align-middle table-row-dashed fs-6 gy-4">
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr className="text-start text-muted fw-bold fs-7 text-uppercase">
                <th>Plan</th>
                <th>Sessions</th>
                <th>Price</th>
                <th>Subscribed On</th>
                <th>Approval</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="fw-semibold text-gray-600">
              {memberships.map((sub) => (
                <tr key={sub._id}>
                  <td className="text-dark fw-bold">{sub.plan_id?.title || '—'}</td>
                  <td>
                    {sub.plan_id?.is_unlimited_sessions ? (
                      <span className="badge badge-light-info">Unlimited</span>
                    ) : (
                      <span>{sub.plan_id?.no_sessions ?? '—'}</span>
                    )}
                  </td>
                  <td>{sub.plan_id?.price ?? '—'}</td>
                  <td>{sub.createdAt ? moment(sub.createdAt).format('DD MMM YYYY') : '—'}</td>
                  <td>
                    <span className={`badge ${approvalBadge(sub.approval_status)}`}>
                      {sub.approval_status || 'Approved'}
                    </span>
                  </td>
                  <td className="mt-2">
                    {sub.approval_status === 'Pending' ? (
                      <>
                        <button
                          onClick={() => updateApproval(sub._id, 'Approved')}
                          className="btn btn-sm h-35px btn-light-success"
                          title="Approve"
                        >
                          <i className="bi bi-check-lg fs-6"></i>
                        </button>
                        <button
                          onClick={() => updateApproval(sub._id, 'Rejected')}
                          className="btn btn-sm h-35px btn-light-danger ms-2"
                          title="Reject"
                        >
                          <i className="bi bi-x-lg fs-6"></i>
                        </button>
                      </>
                    ) : (
                      <span className="text-muted">—</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        )}
      </div>
    </div>
  );
};

export default CustomerMemberships;
